import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import CheckCircle from '@material-ui/icons/CheckCircleOutline';

import styles from './styles';
import { strToKebab } from '../../../utilities/helpers';

const propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    }),
  ).isRequired,
  classes: PropTypes.shape({
    buttonRoot: PropTypes.string,
    normalButtonRoot: PropTypes.string,
    selectedButtonRoot: PropTypes.string,
    buttonIcon: PropTypes.string,
  }).isRequired,
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export const ButtonSelectFormField = props => {
  const { id, value, options, label, classes, onChange } = props;

  const getValArray = val => {
    if (!value) return [];
    return val.trim().split(' & ');
  };

  const renderOptionButton = option => {
    if (!value) {
      return renderNormalButton(option);
    }

    if (getValArray(value).includes(option.value)) {
      return renderSelectedButton(option);
    }

    return renderNormalButton(option);
  };

  const renderSelectedButton = option => (
    <Button
      id={`${id}-${strToKebab(option.value)}`}
      className={classNames(classes.buttonRoot, classes.selectedButtonRoot)}
      key={option.value}
      aria-label={option.label}
      variant="outlined"
      onClick={() => handleClickOptionButton(option.value)}
      data-test="selected-option"
    >
      <CheckCircle className={classes.buttonIcon} />
      {option.label}
    </Button>
  );

  const handleClickOptionButton = optionValue => {
    const valArray = getValArray(value);

    if (valArray.includes(optionValue)) {
      // this option has been selected, so we deselect it
      onChange(valArray.filter(item => item !== optionValue).join(' & '));
      return;
    }

    // this option has not been selected, so we select it
    onChange(valArray.concat(optionValue).join(' & '));
  };

  const renderNormalButton = option => (
    <Button
      id={`${id}-${strToKebab(option.value)}`}
      className={classNames(classes.buttonRoot, classes.normalButtonRoot)}
      key={option.value}
      aria-label={option.label}
      variant="outlined"
      onClick={() => handleClickOptionButton(option.value)}
      data-test="unselected-option"
    >
      {option.label}
    </Button>
  );

  return (
    <div>
      <div className={classes.label}>{label}</div>
      {options.map(option => renderOptionButton(option))}
    </div>
  );
};

ButtonSelectFormField.propTypes = propTypes;

export default withStyles(styles)(ButtonSelectFormField);
